import "./styles.css";
import firebase from "firebase/app";
import "firebase/database";
import React from "react";
var bots;

// Firebase Initialization
const firebaseConfig = {
  apiKey: "AIzaSyDU7iJzXQcGiNCkClR6VZ8O6Fr37DK7hZ0",
  authDomain: "switchbot-84416.firebaseapp.com",
  databaseURL: "https://switchbot-84416-default-rtdb.firebaseio.com",
  projectId: "switchbot-84416",
  storageBucket: "switchbot-84416.appspot.com",
  messagingSenderId: "449877164378",
  appId: "1:449877164378:web:98e4f3953bc0b3da5d7363",
  measurementId: "G-QWSM311P1J"
};

firebase.initializeApp(firebaseConfig);

class Bot {
  /*
  Create a bot object. The bot objects are virtual 
  representations of the physical robots.
  */
  constructor(name, id, clicksStatus, hookStatusChanged, hooked, pull) {
    /*
    Initializes the robot by capturing values from firebase.

    parameters
    ----------
    name - name of robot
    id - id of robot
    clickStatus - tells whether the robot needs to 
                  click the switch
    hookStatusChanged - tells whether the hooked status
                        has been changed.
    hooked - tells what is the current hook status.
    pull - tells whether the clickbot needs to pull the switch.

    return
    ------
    no return
    */
    this.name = name;
    this.id = id;
    this.clicksStatus = clicksStatus;
    this.hookStatusChanged = hookStatusChanged;
    this.hooked = hooked;
    this.pull = pull;
  }
  handleButtonClick(button) {
    switch (button) {
      case "click":
        firebase.database().ref(this.id).update({
          clickStatus: 1
        });
        console.log("click");
        break;
      case "pull":
        firebase.database().ref(this.id).update({
          pull: 1
        });
        console.log("pull");
        break;
      case "changeHookStatus":
        // Change hook Status
        if (this.hooked === 1) {
          firebase.database().ref(this.id).update({
            hooked: 0,
          });
        } else {
          firebase.database().ref(this.id).update({
            hooked: 1,
          });
        }
    
        // Tell clickbot that hook status has been changed
        firebase.database().ref(this.id).update({
          hookStatusChanged: 1,
        });
        console.log("changeHookStatus");
        break;
      default:
        // nothing to do here
        break;
    }
  }
  hookStatusAndPullButton() {
    /*
    Create button element for changing clickbot hook
    status.

    parameters
    ----------
    no parameters

    return
    ------
    button - jsx code for the button
    */
    if (this.hooked === 0) {
      return (
        <div>
          <button style={{ marginTop: "10px" }} disabled>
            Pull
          </button>
          <button
            onClick={() => {
              this.handleButtonClick("changeHookStatus");
            }}
            style={{ marginTop: "10px" }}
          >
            Enable Hooked Mode
          </button>
        </div>
      );
    }
    return (
      <div>
        <button
          onClick={() => {
            this.handleButtonClick("pull");
          }}
          style={{ marginTop: "10px" }}
        >
          Pull
        </button>
        <button
          onClick={() => {
            this.handleButtonClick("changeHookStatus");
          }}
          style={{ marginTop: "10px" }}
        >
          Disable Hooked Mode
        </button>
      </div>
    );
  }
  BotInterface() {
    /*
    Creates a user interface to communicate with robot

    parameters
    ----------
    no parameters

    return
    ------
    controlBox - a box containing all the controls
                for the bot
    */
    var controlBoxStyling = {
      width: "100px",
      //backgroundColor: 'grey',
      border: "2px solid grey",
      padding: "50px",
      margin: "20px",
      borderRadius: "10px"
    };
    var controlBox = (
      <div key={this.id} style={controlBoxStyling}>
        {this.name}
        {/*
        Elements needed
        1. Button to change clickStatus
        2. Button to change pull status
        3. Button to change hookedStatus
        */}
        <br />
        <button
          onClick={() => {
            this.handleButtonClick("click");
          }}
          style={{ marginTop: "10px" }}
        >
          Click
        </button>
        <br />
        {this.hookStatusAndPullButton()}
      </div>
    );
    return controlBox;
  }
}

//Create bots list
var botCount = firebase.database().ref();

export default class Bots extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bots: "Loading..."
    };
  }
  componentDidMount() {
    botCount.on("value", (snapshot) => {
      const data = snapshot.val();
      bots = [];
      // Iterate through bots in firebase
      for (let bot in data) {
        //console.log(data[bot]);
        let clickbot = new Bot(
          data[bot].name,
          bot, // id
          data[bot].clickStatus,
          data[bot].hookStatusChanged,
          data[bot].hooked,
          data[bot].pull
        );
        // Create interface for cotrolling bots
        //bots.push(clickbot.name);
        bots.push(clickbot.BotInterface());
        console.log(clickbot);
      }
      this.setState({
        bots: bots
      });
    });
  }

  render() {
    return <div className="App">{this.state.bots}</div>;
  }
}
